import * as autoLoans from './auto-loans';
import * as banking from './banking';
import * as creditCards from './credit-cards';
import * as educationLoans from './education-loans';
import * as investing from './investing';
import * as mortgages from './mortgages';
import * as personalLoans from './personal-loans';
import * as smbLoans from './small-medium-business-loans';
export default {
  autoLoans: autoLoans,
  banking: banking,
  creditCards: creditCards,
  educationLoans: educationLoans,
  investing: investing,
  mortgages: mortgages,
  personalLoans: personalLoans,
  smbLoans: smbLoans
};